 <button
    class="btn {{style}} {{className}}"
    type="{{type}}"
  >
    {{text}}
  </button>
